// Registro compartido de "trabajo sin guardar" en curso.
//
// Sirve para que el auto-update del frontend (versionWatcher.js) NUNCA recargue la
// página en el medio de algo importante: un agente escribiendo una respuesta, llenando
// el modal de resolver un ticket, etc. Cada superficie que tiene estado en memoria que
// se perdería con un reload registra una "clave sucia" mientras tiene contenido, y la
// limpia al enviar/cerrar. El watcher pregunta hasUnsavedWork() antes de auto-aplicar.
//
// Es a propósito minúsculo y sin dependencias: se importa desde componentes React y
// también se consulta desde versionWatcher.js (que corre fuera de React) vía window.

const dirtyKeys = new Set();

export function markDirty(key) {
  if (!key) return;
  dirtyKeys.add(key);
}

export function clearDirty(key) {
  if (!key) return;
  dirtyKeys.delete(key);
}

// True si hay CUALQUIER superficie con trabajo sin guardar en memoria.
export function hasUnsavedWork() {
  return dirtyKeys.size > 0;
}

// Lista de claves sucias (debug / futuro: mostrar qué está pendiente).
export function unsavedKeys() {
  return Array.from(dirtyKeys);
}

// Puente para versionWatcher.js, que no es un módulo React y lee del window.
if (typeof window !== 'undefined') {
  window.__hdHasUnsavedWork = hasUnsavedWork;
}
